<template>
  <canvas :id="'code-' + id" style="width: 120px;height: 120px;"></canvas>
</template>
<script>
import QRCode from 'qrcode'
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },
  mounted() {
    setTimeout(() => {
      this.create();
    }, 200)
  },
  methods: {
    create() {
      const canvas = document.querySelector('#code-' + this.id);
      const ctx = canvas.getContext('2d');
      QRCode.toDataURL(this.url, {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.8,
        margin: 1,
      }, (err, url) => {
        if (err) throw err
        const img = new Image();
        img.src = url;
        canvas.height = 480;
        canvas.width = 480;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, 480, 480);
        try {
          ctx.drawImage(img, 40, 40, 400, 400);
        } catch (error) {
          console.log(error)
        }
      });
    }
  }
}
</script>
